import { InjectionToken, Injectable, Inject, ɵɵdefineInjectable, ɵɵinject, EventEmitter, Component, NgModule } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { __awaiter } from 'tslib';
import { Log, UserManager } from 'oidc-client';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { CallHttp, PageNotFoundComponent, VestaModule } from 'vesta';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/user-auth.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IUserAuth() { }
if (false) {
    /** @type {?} */
    IUserAuth.prototype.Role;
    /** @type {?} */
    IUserAuth.prototype.Email;
    /** @type {?} */
    IUserAuth.prototype.Name;
    /** @type {?} */
    IUserAuth.prototype.UserName;
    /** @type {?} */
    IUserAuth.prototype.Id;
    /** @type {?} */
    IUserAuth.prototype.User;
    /** @type {?} */
    IUserAuth.prototype.UserEvent;
}
/** @type {?} */
let USER_AUTH = new InjectionToken('IUserAuth');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/authentication-providers.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
let CLIENT_SETTINGS = new InjectionToken('ClientSettings');
/** @type {?} */
let BASEURL_AUTENTICACION = new InjectionToken('BASEURLAUTENTICACION');
/** @type {?} */
let BASEURL_AUTENTICACION_WEB = new InjectionToken('BASEURLAUTENTICACIONWEB');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/client-settings.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ClientSettings {
    /**
     * @param {?} settings
     * @param {?} urlWeb
     */
    constructor(settings, urlWeb) {
        this.settings = settings;
        this.urlWeb = urlWeb;
        this._authority = this.urlWeb; //'https://vestaidentityserver.azurewebsites.net/'; //"https://identitysrvv.azurewebsites.net/"; //"https://identitysrvdev.azurewebsites.net/";
        this._client_id = this.settings.ClienteId; //"mario_js_client";
        this._redirect_uri = window.location.origin + "/auth-callback";
        this._post_logout_redirect_uri = window.location.origin + "/";
        // if we choose to use popup window instead for logins
        this._popup_redirect_uri = window.location.origin + "/popup.html";
        this._popupWindowFeatures = "menubar=yes,location=yes,toolbar=yes,width=1200,height=800,left=100,top=100;resizable=yes";
        // these two will be done dynamically from the buttons clicked, but are
        // needed if you want to use the silent_renew
        this._response_type = "code";
        //response_mode= "query",
        this._scope = "openid profile IdentitySrvApi"; //work.profile//IdentityServerApi api1 api1.full_access api2.full_access // IdentitySrvApi
        // this will toggle if profile endpoint is used
        this._loadUserInfo = true;
        //userStore= new WebStorageStateStore({ store= window.localStorage }),
        // silent renew will get a new access_token via an iframe 
        // just prior to the old access_token expiring (60 seconds prior)
        this._silent_redirect_uri = window.location.origin + "/auth-silent";
        this._automaticSilentRenew = true;
        // will revoke (reference) access tokens at logout time
        this._revokeAccessTokenOnSignout = true;
        // this will allow all the OIDC protocol claims to be visible in the window. normally a client app 
        // wouldn't care about them or want them taking up space
        this._filterProtocolClaims = true;
        this._extraQueryParams = {}; //sistema_id: this.settings.SistemaId
    }
    //'https://vestaidentityserver.azurewebsites.net/'; //"https://identitysrvv.azurewebsites.net/"; //"https://identitysrvdev.azurewebsites.net/";
    /**
     * @return {?}
     */
    get authority() {
        return this._authority;
    }
    //"mario_js_client";
    /**
     * @return {?}
     */
    get client_id() {
        return this._client_id;
    }
    /**
     * @return {?}
     */
    get redirect_uri() {
        return this._redirect_uri;
    }
    /**
     * @return {?}
     */
    get post_logout_redirect_uri() {
        return this._post_logout_redirect_uri;
    }
    /**
     * @return {?}
     */
    get popup_redirect_uri() {
        return this._popup_redirect_uri;
    }
    /**
     * @return {?}
     */
    get popupWindowFeatures() {
        return this._popupWindowFeatures;
    }
    ;
    /**
     * @return {?}
     */
    get response_type() {
        return this._response_type;
    }
    //work.profile//IdentityServerApi api1 api1.full_access api2.full_access // IdentitySrvApi
    /**
     * @return {?}
     */
    get scope() {
        return this._scope;
    }
    /**
     * @return {?}
     */
    get loadUserInfo() {
        return this._loadUserInfo;
    }
    /**
     * @return {?}
     */
    get silent_redirect_uri() {
        return this._silent_redirect_uri;
    }
    /**
     * @return {?}
     */
    get automaticSilentRenew() {
        return this._automaticSilentRenew;
    }
    /**
     * @return {?}
     */
    get revokeAccessTokenOnSignout() {
        return this._revokeAccessTokenOnSignout;
    }
    /**
     * @return {?}
     */
    get filterProtocolClaims() {
        return this._filterProtocolClaims;
    }
    //sistema_id: this.settings.SistemaId
    /**
     * @return {?}
     */
    get extraQueryParams() {
        return this._extraQueryParams;
    }
}
ClientSettings.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ClientSettings.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [CLIENT_SETTINGS,] }] },
    { type: String, decorators: [{ type: Inject, args: [BASEURL_AUTENTICACION_WEB,] }] }
];
/** @nocollapse */ ClientSettings.ngInjectableDef = ɵɵdefineInjectable({ factory: function ClientSettings_Factory() { return new ClientSettings(ɵɵinject(CLIENT_SETTINGS), ɵɵinject(BASEURL_AUTENTICACION_WEB)); }, token: ClientSettings, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype._authority;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype._client_id;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype._redirect_uri;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype._post_logout_redirect_uri;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype._popup_redirect_uri;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype._popupWindowFeatures;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype._response_type;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype._scope;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype._loadUserInfo;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype._silent_redirect_uri;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype._automaticSilentRenew;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype._revokeAccessTokenOnSignout;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype._filterProtocolClaims;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype._extraQueryParams;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype.settings;
    /**
     * @type {?}
     * @private
     */
    ClientSettings.prototype.urlWeb;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/auth.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
Log.logger = window.console;
Log.level = Log.DEBUG;
class AuthService {
    //  new Promise((resolve, reject) => {
    //  this.manager.getUser().then(response => {
    //    resolve(response);
    //  }, error => {
    //    reject(error);
    //  })    
    //})
    /**
     * @param {?} router
     * @param {?} clientSettings
     */
    constructor(router, clientSettings) {
        this.router = router;
        this.clientSettings = clientSettings;
        this.manager = new UserManager(this.clientSettings);
        this.user = null;
        this.UserEvent = new EventEmitter();
        this._first = true;
        this.AsyncUser();
    }
    /**
     * @private
     * @return {?}
     */
    AsyncUser() {
        return __awaiter(this, void 0, void 0, function* () {
            this.user = yield this.manager.getUser();
            //this.UserEvent.emit(this.user);
        });
    }
    /**
     * @return {?}
     */
    isLoggedIn() {
        if (this._first) {
            this._first = false;
            if (this.user)
                this.UserEvent.emit(this.user);
            //else this.UserEvent.emit(new User(null));
        }
        return this.user != null && !this.user.expired;
    }
    /**
     * @return {?}
     */
    getClaims() {
        return this.user.profile;
    }
    /**
     * @return {?}
     */
    getAuthorizationHeaderValue() {
        return `${this.user.token_type} ${this.user.access_token}`;
    }
    /**
     * @return {?}
     */
    startAuthentication() {
        return this.manager.signinRedirect();
    }
    /**
     * @return {?}
     */
    completeAuthentication() {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let user = yield this.manager.signinRedirectCallback();
            this.user = user;
            this._first = false;
            this.UserEvent.emit(this.user);
            //let dirStorage = localStorage.getItem("history");
            //let dir = (dirStorage == null) ? '/menu' : dirStorage;
            this.router.navigate(['/menu']);
        });
    }
    /**
     * @return {?}
     */
    signoutRedirect() {
        return this.manager.signoutRedirect();
    }
    /**
     * @return {?}
     */
    signinSilentCallback() {
        this.manager.signinSilentCallback();
    }
    /**
     * @return {?}
     */
    GetIUserAuth() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.user == null)
                this.user = yield this.manager.getUser();
            if (this.user != null) {
                /** @type {?} */
                let user = {
                    Role: this.user.profile.JobRole,
                    Email: this.user.profile.preferred_username,
                    Name: this.user.profile.name,
                    UserName: this.user.profile.preferred_username,
                    Id: this.user.profile.sub.toLowerCase(),
                    User: null,
                    UserEvent: null
                };
                return user;
            }
            else {
                return {
                    Role: null,
                    Email: null,
                    Name: null,
                    UserName: null,
                    Id: null,
                    User: null,
                    UserEvent: null
                };
            }
        });
    }
}
AuthService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
AuthService.ctorParameters = () => [
    { type: Router },
    { type: ClientSettings }
];
/** @nocollapse */ AuthService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(ɵɵinject(Router), ɵɵinject(ClientSettings)); }, token: AuthService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    AuthService.prototype.manager;
    /**
     * @type {?}
     * @private
     */
    AuthService.prototype.user;
    /** @type {?} */
    AuthService.prototype.UserEvent;
    /**
     * @type {?}
     * @private
     */
    AuthService.prototype._first;
    /**
     * @type {?}
     * @private
     */
    AuthService.prototype.router;
    /**
     * @type {?}
     * @private
     */
    AuthService.prototype.clientSettings;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/authorization-guard.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthorizationGuard {
    /**
     * @param {?} router
     * @param {?} authService
     */
    constructor(router, authService) {
        this.router = router;
        this.authService = authService;
        router.events.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        value => {
            if (value instanceof NavigationEnd) {
                localStorage.removeItem("history");
                /** @type {?} */
                let url = value.url.split('(')[0];
                localStorage.setItem("history", url);
            }
        }));
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    canActivate(route, state) {
        return this.checkUser();
    }
    /**
     * @return {?}
     */
    canLoad() {
        return this.checkUser();
    }
    /**
     * @private
     * @return {?}
     */
    checkUser() {
        if (this.authService.isLoggedIn()) {
            return true;
        }
        this.authService.startAuthentication();
        return false;
    }
}
AuthorizationGuard.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
AuthorizationGuard.ctorParameters = () => [
    { type: Router },
    { type: AuthService }
];
/** @nocollapse */ AuthorizationGuard.ngInjectableDef = ɵɵdefineInjectable({ factory: function AuthorizationGuard_Factory() { return new AuthorizationGuard(ɵɵinject(Router), ɵɵinject(AuthService)); }, token: AuthorizationGuard, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    AuthorizationGuard.prototype.router;
    /**
     * @type {?}
     * @private
     */
    AuthorizationGuard.prototype.authService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/user-auth.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UserAuth {
    /**
     * @param {?} auth
     */
    constructor(auth) {
        this.auth = auth;
        this._UserEvent = new EventEmitter();
        auth.UserEvent.subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this._Role = response.profile.JobRole;
            this._Email = response.profile.preferred_username;
            this._Name = response.profile.name;
            this._UserName = response.profile.preferred_username;
            this._Id = response.profile.sub; //"BC55E46F-0B31-45D1-B1E1-1450C63CD32F"//response.profile.sub
            this._UserEvent.emit(this);
        }));
        this.GetUserAsync();
    }
    /**
     * @private
     * @return {?}
     */
    GetUserAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let user = yield this.auth.GetIUserAuth();
            if (user != null) {
                this._Role = user.Role;
                this._Email = user.Email;
                this._Name = user.Name;
                this._UserName = user.UserName;
                this._Id = user.Id; //'BC55E46F-0B31-45D1-B1E1-1450C63CD32F'//user.Id
                //if (user != null) this._UserEvent.emit(this);
            }
        });
    }
    //private _User;
    /**
     * @return {?}
     */
    get User() {
        return this.UserASync();
    }
    /**
     * @return {?}
     */
    UserASync() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.auth.GetIUserAuth();
        });
    }
    /**
     * @return {?}
     */
    get UserEvent() {
        return this._UserEvent;
    }
    /**
     * @return {?}
     */
    get Role() {
        return this._Role;
    }
    /**
     * @return {?}
     */
    get Email() {
        return this._Email;
    }
    /**
     * @return {?}
     */
    get Name() {
        return this._Name;
    }
    /**
     * @return {?}
     */
    get UserName() {
        return this._UserName;
    }
    /**
     * @return {?}
     */
    get Id() {
        if (this._Id == null)
            return null;
        return this._Id.toLocaleLowerCase();
    }
}
UserAuth.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
UserAuth.ctorParameters = () => [
    { type: AuthService }
];
/** @nocollapse */ UserAuth.ngInjectableDef = ɵɵdefineInjectable({ factory: function UserAuth_Factory() { return new UserAuth(ɵɵinject(AuthService)); }, token: UserAuth, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    UserAuth.prototype._UserEvent;
    /**
     * @type {?}
     * @private
     */
    UserAuth.prototype._Role;
    /**
     * @type {?}
     * @private
     */
    UserAuth.prototype._Email;
    /**
     * @type {?}
     * @private
     */
    UserAuth.prototype._Name;
    /**
     * @type {?}
     * @private
     */
    UserAuth.prototype._UserName;
    /**
     * @type {?}
     * @private
     */
    UserAuth.prototype._Id;
    /**
     * @type {?}
     * @private
     */
    UserAuth.prototype.auth;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/http-access-token-interceptor.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HttpAccessTokenInterceptorService {
    /**
     * @param {?} authService
     * @param {?} settings
     */
    constructor(authService, settings) {
        this.authService = authService;
        this.settings = settings;
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    intercept(req, next) {
        //this.RequestInterceptor();
        if (req.withCredentials) {
            /** @type {?} */
            let accessToken = this.authService.getAuthorizationHeaderValue();
            /** @type {?} */
            const handler = req.clone({
                setHeaders: { Authorization: accessToken, WWWAuths: `${this.settings.ClienteId}, ${window.location.origin}, ${window.location.pathname}` },
                withCredentials: false
            });
            return next.handle(handler).pipe(tap((/**
             * @return {?}
             */
            () => { }), (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                if (error instanceof HttpErrorResponse) {
                    if (error.status != 401)
                        return void 0;
                    this.authService.startAuthentication();
                    //this.router.navigate(['/menu']);
                }
            })));
        }
        return next.handle(req);
    }
}
HttpAccessTokenInterceptorService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
HttpAccessTokenInterceptorService.ctorParameters = () => [
    { type: AuthService },
    { type: undefined, decorators: [{ type: Inject, args: [CLIENT_SETTINGS,] }] }
];
/** @nocollapse */ HttpAccessTokenInterceptorService.ngInjectableDef = ɵɵdefineInjectable({ factory: function HttpAccessTokenInterceptorService_Factory() { return new HttpAccessTokenInterceptorService(ɵɵinject(AuthService), ɵɵinject(CLIENT_SETTINGS)); }, token: HttpAccessTokenInterceptorService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    HttpAccessTokenInterceptorService.prototype.authService;
    /**
     * @type {?}
     * @private
     */
    HttpAccessTokenInterceptorService.prototype.settings;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/auth-service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IAuthService() { }
if (false) {
    /**
     * @return {?}
     */
    IAuthService.prototype.signoutRedirect = function () { };
}
/** @type {?} */
let AUTH_SERVICE = new InjectionToken('IAuthService');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/auth-callback/auth-callback.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthCallbackComponent {
    /**
     * @param {?} authService
     */
    constructor(authService) {
        this.authService = authService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.Init();
        });
    }
    /**
     * @return {?}
     */
    Init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authService.completeAuthentication();
        });
    }
}
AuthCallbackComponent.decorators = [
    { type: Component, args: [{
                selector: 'auth-callback',
                template: "<h1>Processing callback...</h1>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
AuthCallbackComponent.ctorParameters = () => [
    { type: AuthService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    AuthCallbackComponent.prototype.authService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/auth-silent/auth-silent.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthSilentComponent {
    /**
     * @param {?} authService
     */
    constructor(authService) {
        this.authService = authService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.authService.signinSilentCallback();
    }
}
AuthSilentComponent.decorators = [
    { type: Component, args: [{
                selector: 'auth-silent',
                template: "<p>auth-silent works!</p>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
AuthSilentComponent.ctorParameters = () => [
    { type: AuthService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    AuthSilentComponent.prototype.authService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/menu-authentication.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MenuAuthenticationService {
    /**
     * @param {?} callHttp
     * @param {?} settings
     * @param {?} urlBase
     * @param {?} userAuth
     */
    constructor(callHttp, settings, urlBase, userAuth) {
        this.callHttp = callHttp;
        this.settings = settings;
        this.urlBase = urlBase;
        this.userAuth = userAuth;
        this._MenuAuthentication = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            //Opers/Sistema/Home/GetMenu
            //Opers/Project/Home/GetMenu
            //, { ProjectId: this.settings.SistemaId, UserId: this.userAuth.Id }
            ///api/IdentityApi/GetMenuTestMS
            ///api/IdentityApi/GetMenu
            this.callHttp.httpGet(`${this.urlBase}/api/IdentityApi/GetMenu`)
                .subscribe((/**
             * @param {?} response
             * @return {?}
             */
            response => {
                resolve(response);
            }), (/**
             * @param {?} error
             * @return {?}
             */
            error => {
                reject(error);
            }));
        }));
    }
    /**
     * @return {?}
     */
    get MenuAuthentication() {
        return this._MenuAuthentication;
    }
}
MenuAuthenticationService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
MenuAuthenticationService.ctorParameters = () => [
    { type: CallHttp },
    { type: undefined, decorators: [{ type: Inject, args: [CLIENT_SETTINGS,] }] },
    { type: String, decorators: [{ type: Inject, args: [BASEURL_AUTENTICACION,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [USER_AUTH,] }] }
];
/** @nocollapse */ MenuAuthenticationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function MenuAuthenticationService_Factory() { return new MenuAuthenticationService(ɵɵinject(CallHttp), ɵɵinject(CLIENT_SETTINGS), ɵɵinject(BASEURL_AUTENTICACION), ɵɵinject(USER_AUTH)); }, token: MenuAuthenticationService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    MenuAuthenticationService.prototype._MenuAuthentication;
    /**
     * @type {?}
     * @private
     */
    MenuAuthenticationService.prototype.callHttp;
    /**
     * @type {?}
     * @private
     */
    MenuAuthenticationService.prototype.settings;
    /**
     * @type {?}
     * @private
     */
    MenuAuthenticationService.prototype.urlBase;
    /**
     * @type {?}
     * @private
     */
    MenuAuthenticationService.prototype.userAuth;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-authentication.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//let Routes_Vesta = new InjectionToken<Routes>('RoutesVesta');
//let routesRoot: Routes = [];
/**
 * @param {?} settings
 * @return {?}
 */
function InitWebApi(settings) {
    /** @type {?} */
    let direccion = 'https://vestaidentityserverapi.azurewebsites.net';
    if (settings.Stage)
        direccion = 'https://vestaidentityserverapi-stage.azurewebsites.net';
    // let [direccionWeb] = DireccionesFileShare.filter(f => f.Nombre == direccion);
    return direccion;
}
/**
 * @param {?} settings
 * @return {?}
 */
function InitWeb(settings) {
    /** @type {?} */
    let direccion = 'https://vestaidentityserver.azurewebsites.net/';
    if (settings.Stage)
        direccion = 'https://vestaidentityserver-stage.azurewebsites.net/';
    // let [direccionWeb] = DireccionesFileShare.filter(f => f.Nombre == direccion);
    return direccion;
}
/** @type {?} */
var routes = [
    { path: 'auth-callback', component: AuthCallbackComponent },
    { path: 'auth-silent', component: AuthSilentComponent },
    { path: '**', component: PageNotFoundComponent }
];
class VestaAuthenticationModule {
    /**
     * @param {?} settings
     * @return {?}
     */
    static forRoot(settings) {
        //let provide = { provide: CLIENT_SETTINGS, useValue: settings };
        //let providers = [provide];
        return {
            ngModule: VestaAuthenticationModule,
            providers: [
                { provide: CLIENT_SETTINGS, useValue: settings },
                { provide: BASEURL_AUTENTICACION, useFactory: InitWebApi, deps: [CLIENT_SETTINGS] },
                { provide: BASEURL_AUTENTICACION_WEB, useFactory: InitWeb, deps: [CLIENT_SETTINGS] },
            ]
        };
    }
}
VestaAuthenticationModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    AuthCallbackComponent,
                    AuthSilentComponent
                ],
                imports: [
                    CommonModule,
                    RouterModule.forRoot(routes),
                    VestaModule
                ],
                exports: [
                    AuthCallbackComponent,
                    AuthSilentComponent
                    //RouterModule
                ],
                providers: [
                    AuthorizationGuard,
                    AuthService,
                    MenuAuthenticationService,
                    { provide: USER_AUTH, useClass: UserAuth },
                    { provide: AUTH_SERVICE, useClass: AuthService },
                    { provide: HTTP_INTERCEPTORS, useClass: HttpAccessTokenInterceptorService, multi: true },
                    //{ provide: BASEURL_AUTENTICACION, useValue: 'https://vestaidentityserverapi.azurewebsites.net' },//'https://identitysrvv-api.azurewebsites.net'
                    ClientSettings
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-authentication.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function Backlog() { }
if (false) {
    /** @type {?} */
    Backlog.prototype.Id;
    /** @type {?} */
    Backlog.prototype.Description;
    /** @type {?} */
    Backlog.prototype.Nombre;
    /** @type {?} */
    Backlog.prototype.Uri;
}
/**
 * @record
 */
function Feature() { }
if (false) {
    /** @type {?} */
    Feature.prototype.Id;
    /** @type {?} */
    Feature.prototype.Description;
    /** @type {?} */
    Feature.prototype.Uri;
    /** @type {?} */
    Feature.prototype.Nombre;
    /** @type {?} */
    Feature.prototype.Backlogs;
}
/**
 * @record
 */
function Epic() { }
if (false) {
    /** @type {?} */
    Epic.prototype.Id;
    /** @type {?} */
    Epic.prototype.Description;
    /** @type {?} */
    Epic.prototype.Nombre;
    /** @type {?} */
    Epic.prototype.Uri;
    /** @type {?} */
    Epic.prototype.Features;
}
/**
 * @record
 */
function AuthenticationMenu() { }
if (false) {
    /** @type {?} */
    AuthenticationMenu.prototype.Id;
    /** @type {?} */
    AuthenticationMenu.prototype.Description;
    /** @type {?} */
    AuthenticationMenu.prototype.Epics;
}
class AuthenticationMenuMock {
    /**
     * @return {?}
     */
    static GetAuthenticationMenuMock() {
        /** @type {?} */
        let obj = (/** @type {?} */ ({}));
        return obj;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-authentication-user/vesta-authentication-user.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VestaAuthenticationUserModule {
}
VestaAuthenticationUserModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                imports: [
                    CommonModule
                ],
                providers: [{ provide: USER_AUTH, useClass: UserAuth },
                    { provide: AUTH_SERVICE, useClass: AuthService }]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: vesta-authentication.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AUTH_SERVICE, AuthenticationMenuMock, AuthorizationGuard, InitWeb, InitWebApi, MenuAuthenticationService, USER_AUTH, VestaAuthenticationModule, VestaAuthenticationUserModule, AuthService as ɵa, ClientSettings as ɵb, CLIENT_SETTINGS as ɵc, BASEURL_AUTENTICACION as ɵd, BASEURL_AUTENTICACION_WEB as ɵe, AuthCallbackComponent as ɵf, AuthSilentComponent as ɵg, UserAuth as ɵh, HttpAccessTokenInterceptorService as ɵi };
//# sourceMappingURL=vesta-authentication.js.map
